var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.529247 0.52827C0.789596 0.26792 1.21171 0.26792 1.47206 0.52827L5.00065 4.05687L8.52925 0.52827C8.7896 0.26792 9.21171 0.26792 9.47206 0.52827C9.73241 0.788619 9.73241 1.21073 9.47206 1.47108L5.47206 5.47108C5.21171 5.73143 4.7896 5.73143 4.52925 5.47108L0.529247 1.47108C0.268897 1.21073 0.268897 0.788619 0.529247 0.52827Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.6992054ec5d9d119413481ccfb801182.svg";
export { ForwardRef as ReactComponent };